document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-miivo-contact]').forEach(root => {
    if (root.dataset.uploadEnabled !== 'true') return;

    const form = root.querySelector('form');
    const input = root.querySelector('[data-miivo-file]');
    const dropzone = root.querySelector('[data-miivo-dropzone]');
    const choose = root.querySelector('[data-miivo-choose]');
    const selected = root.querySelector('[data-miivo-selected]');
    const filename = root.querySelector('[data-miivo-filename]');
    const filesize = root.querySelector('[data-miivo-filesize]');
    const remove = root.querySelector('[data-miivo-remove]');
    const progress = root.querySelector('[data-miivo-progress]');
    const progressBar = root.querySelector('[data-miivo-progress-bar]');
    const status = root.querySelector('[data-miivo-status]');
    const submit = root.querySelector('[data-miivo-submit]');
    const urlField = root.querySelector('[data-miivo-file-url]');
    const nameField = root.querySelector('[data-miivo-file-name]');
    const typeField = root.querySelector('[data-miivo-file-type]');

    if (!form || !input) return;

    const allowed = new Set([
      'svg','dxf','png','jpg','jpeg','bmp','webp','pdf',
      'tif','tiff','gif','psd','xcs','xs'
    ]);

    let currentFile = null;
    let uploadCompletedFor = '';

    const formatBytes = bytes => {
      if (!Number.isFinite(bytes)) return '';
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
    };

    const extension = name => (name.split('.').pop() || '').toLowerCase();

    const setStatus = (message = '', type = '') => {
      status.textContent = message;
      status.classList.toggle('is-error', type === 'error');
      status.classList.toggle('is-success', type === 'success');
    };

    const clearFile = () => {
      currentFile = null;
      uploadCompletedFor = '';
      input.value = '';
      urlField.value = '';
      nameField.value = '';
      typeField.value = '';
      selected.hidden = true;
      progress.hidden = true;
      progressBar.style.width = '0%';
      setStatus('');
    };

    const validate = file => {
      if (!file) return 'Bitte wähle eine Datei aus.';
      const ext = extension(file.name);
      if (!allowed.has(ext)) {
        return 'Dieses Dateiformat wird nicht unterstützt. Bitte verwende ein kompatibles Format.';
      }
      const maxBytes = Number(root.dataset.maxMb || 20) * 1024 * 1024;
      if (file.size > maxBytes) {
        return `Die Datei ist größer als ${root.dataset.maxMb || 20} MB.`;
      }
      return '';
    };

    const selectFile = file => {
      const error = validate(file);
      if (error) {
        clearFile();
        setStatus(error, 'error');
        return;
      }
      currentFile = file;
      uploadCompletedFor = '';
      urlField.value = '';
      nameField.value = file.name;
      typeField.value = extension(file.name).toUpperCase();
      filename.textContent = file.name;
      filesize.textContent = formatBytes(file.size);
      selected.hidden = false;
      setStatus('');
    };

    choose?.addEventListener('click', () => input.click());
    dropzone?.addEventListener('click', e => {
      if (e.target.closest('button')) return;
      input.click();
    });

    input.addEventListener('change', () => selectFile(input.files?.[0]));

    ['dragenter','dragover'].forEach(type => dropzone?.addEventListener(type, e => {
      e.preventDefault();
      dropzone.classList.add('is-dragover');
    }));

    ['dragleave','drop'].forEach(type => dropzone?.addEventListener(type, e => {
      e.preventDefault();
      dropzone.classList.remove('is-dragover');
    }));

    dropzone?.addEventListener('drop', e => {
      const file = e.dataTransfer?.files?.[0];
      if (!file) return;
      const transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
      selectFile(file);
    });

    remove?.addEventListener('click', clearFile);

    const extractUrl = data => {
      if (!data || typeof data !== 'object') return '';
      return data.url || data.file_url || data.secure_url || data.cdn_url || data.fileUrl || '';
    };

    const uploadToUploadcare = async file => {
      const publicKey = (root.dataset.uploadcareKey || '').trim();
      if (!publicKey) {
        throw new Error('Uploadcare ist noch nicht eingerichtet. Bitte im Theme-Editor den Public Key eintragen.');
      }
      const body = new FormData();
      body.append('UPLOADCARE_PUB_KEY', publicKey);
      body.append('UPLOADCARE_STORE', 'auto');
      body.append('file', file);

      const response = await fetch('https://upload.uploadcare.com/base/', {
        method: 'POST',
        body
      });
      if (!response.ok) throw new Error('Der Datei-Upload konnte nicht abgeschlossen werden.');

      const data = await response.json();
      if (!data.file) throw new Error('Uploadcare hat keinen Datei-Link zurückgegeben.');
      return `https://33zwna145n.ucarecd.net/${data.file}/`;
    };

    const uploadToCustom = async file => {
      const endpoint = (root.dataset.customEndpoint || '').trim();
      if (!endpoint) {
        throw new Error('Es ist noch kein eigener Upload-Endpunkt hinterlegt.');
      }
      const body = new FormData();
      body.append('file', file, file.name);

      const response = await fetch(endpoint, {
        method: 'POST',
        body
      });
      if (!response.ok) throw new Error('Der Datei-Upload konnte nicht abgeschlossen werden.');

      const data = await response.json();
      const url = extractUrl(data);
      if (!url) {
        throw new Error('Der Upload-Endpunkt hat keinen unterstützten Datei-Link zurückgegeben.');
      }
      return url;
    };

    const upload = async file => {
      progress.hidden = false;
      progressBar.style.width = '35%';
      setStatus('Datei wird geprüft …');

      const provider = root.dataset.uploadProvider || 'uploadcare';
      let url;
      if (provider === 'custom') url = await uploadToCustom(file);
      else url = await uploadToUploadcare(file);

      progressBar.style.width = '100%';
      urlField.value = url;
      nameField.value = file.name;
      typeField.value = extension(file.name).toUpperCase();
      uploadCompletedFor = `${file.name}:${file.size}:${file.lastModified}`;
      setStatus('Datei erfolgreich hochgeladen.', 'success');
      return url;
    };

    form.addEventListener('submit', async e => {
      const required = root.dataset.uploadRequired === 'true';

      if (!currentFile) {
        if (required) {
          e.preventDefault();
          setStatus('Bitte lade eine Datei hoch.', 'error');
          input.focus();
        }
        return;
      }

      const signature = `${currentFile.name}:${currentFile.size}:${currentFile.lastModified}`;
      if (uploadCompletedFor === signature && urlField.value) return;

      e.preventDefault();
      submit.disabled = true;
      setStatus('');

      try {
        await upload(currentFile);
        submit.disabled = false;
        form.requestSubmit(submit);
      } catch (error) {
        submit.disabled = false;
        progress.hidden = true;
        progressBar.style.width = '0%';
        setStatus(error?.message || 'Der Upload ist fehlgeschlagen.', 'error');
      }
    });
  });
});
